import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'
import { GameCssStyles } from '../GameCssStyles'
import { ANCHOR_TYPE_ARRAY } from '../GameConstant'

const PredictionAnchor = ({ formGameData, showsList, handleChange }) => {
    return (
        <Box sx={GameCssStyles.containerStyleColumn_sx}>
            <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Anchor Settings</Typography>
            <Box sx={GameCssStyles.containerStyleRowWithoutBorder_sx}>
                <FormControl fullWidth margin="normal">
                    <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Anchor </InputLabel>
                    <Select
                        value={formGameData?.anchor?.type || ''}
                        onChange={(e) => {
                            handleChange('anchor.type', e.target.value)
                        }}
                        label="Shows"
                        sx={GameCssStyles.formFiledStyle_sx2}
                    >
                        <MenuItem value="" disabled>
                            Select Show
                        </MenuItem>
                        {ANCHOR_TYPE_ARRAY?.map((item, idx) => {
                            return (<MenuItem
                                key={idx}
                                value={item?.value}
                                sx={GameCssStyles.menuItemStyle_sx}>
                                {item?.label}
                            </MenuItem>)
                        })}
                    </Select>
                </FormControl>

                {Array.isArray(showsList) && showsList.length > 0 && (<FormControl fullWidth margin="normal">
                    <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Show</InputLabel>
                    <Select
                        value={showsList?.some(show => show?._id === formGameData?.anchor?.id) ? formGameData?.anchor?.id : ''}
                        onChange={(e) => {
                            handleChange('anchor.id', e.target.value)
                        }}
                        label="Shows"
                        sx={GameCssStyles.formFiledStyle_sx2}
                    >
                        <MenuItem value="" disabled>
                            Select Show
                        </MenuItem>
                        {showsList?.map((item, idx) => {
                            return (<MenuItem key={idx} value={item?._id} sx={GameCssStyles.menuItemStyle_sx}> {item?.title} </MenuItem>)
                        })}
                    </Select>
                </FormControl>)}
            </Box>
        </Box>
    )
}

export default PredictionAnchor
